<template>
  <div class="box">
    <div class="up">
      <div class="item bg-color-black">
        <div class="d-flex pt-2 pl-2">
            <span>
              <icon name="align-left" class="text-icon"></icon>
            </span>
          <span class="fs-xl text mx-2">性别分布</span>
        </div>
        <div class="percent">
          <div class="item">
            <span>男性占比</span>
            <span> <CenterChart
                :id="rate[0].id"
                :tips="rate[0].tips"
                :colorObj="rate[0].colorData"
            /></span>
          </div>
          <div class="item">
            <span>女性占比</span>
            <span><CenterChart
                :id="rate[1].id"
                :tips="rate[1].tips"
                :colorObj="rate[1].colorData"
            /></span>
          </div>
        </div>
      </div>
    </div>

    <div class="down">
      <div class="item bg-color-black">
        <div class="d-flex pt-2 pl-2">
            <span>
              <icon name="align-left" class="text-icon"></icon>
            </span>
          <span class="fs-xl text mx-2">年龄分布</span>
        </div>
        <div class="d-flex ai-center flex-column body-box">
          <dv-capsule-chart class="dv-cap-chart" :config="config"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CenterChart from '_c/echart/center/centerChartRate'
import {getUserSex, getUserYear} from "@/api/area/left2";

export default {
  data() {
    return {
      // 通过率和达标率的组件复用数据
      rate: [
        {
          id: 'centerRate1',
          tips: 60,
          colorData: {
            textStyle: '#3fc0fb',
            series: {
              color: ['#00bcd44a', 'transparent'],
              dataColor: {
                normal: '#03a9f4',
                shadowColor: '#97e2f5'
              }
            }
          }
        },
        {
          id: 'centerRate2',
          tips: 40,
          colorData: {
            textStyle: '#67e0e3',
            series: {
              color: ['#faf3a378', 'transparent'],
              dataColor: {
                normal: '#ff9800',
                shadowColor: '#fcebad'
              }
            }
          }
        }
      ],
      config: {
        data: [
          {
            name: '0~18岁',
            value: 167
          },
          {
            name: '18~30岁',
            value: 67
          },
          {
            name: '30~40岁',
            value: 123
          },
          {
            name: '40~60岁',
            value: 55
          },
          {
            name: '60岁+',
            value: 98
          }
        ]
      }
    }
  },
  components: {
    CenterChart
  },
  created() {
    this.getData();
  },
  methods: {
    /**
     * 获取数据
     */
    getData() {
      // 性别
      getUserSex().then((res) => {
        if (res.code === "0") {
          this.rate[0].tips = res.data.man;
          this.rate[1].tips = res.data.woman;
        }
      });
      // 年龄
      getUserYear().then((res) => {
        if (res.code === "0") {
          this.config.data[0].value = res.data["0"];
          this.config.data[1].value = res.data["18"];
          this.config.data[2].value = res.data["30"];
          this.config.data[3].value = res.data["40"];
          this.config.data[4].value = res.data["60"];
          this.config = {...this.config}
        }
      });
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/box';

.item {
  width: 100%;
  height: 100%;
}

.percent {
  width: 100%;
  display: flex;
  flex-wrap: wrap;

  .item {
    width: 50%;
    height: 100%;

    span {
      margin-top: 1rem;
      font-size: 14px;
      display: flex;
      justify-content: center;
    }
  }
}

.text {
  color: #c3cbde;
}

.body-box {
  border-radius: 10px;

  .dv-cap-chart {
    width: 100%;
    height: 260px;
  }
}


</style>
